<div
  class="flex justify-center items-center fixed top-0 left-0 right-0 bottom-0 z-10000 bg-sidebar"
>
  <div class="flex flex-col justify-center items-center gap-12">
    <tdv-spinner type="inline" [diameter]="48" [showLogo]="true"></tdv-spinner>
    <div class="text-13 text-gray-300">Logging out...</div>
  </div>
</div>
